<div class="page-title">
  <h2>Aircrafts</h2>
</div>

<div class="table-container">
  <table mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" matSort matSortDisableClear class="aircraft-table">
    <!-- Chevron -->
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="Afficher les détails"></th>
      <td mat-cell *matCellDef="let row" class="cell-expand">
        <button
          mat-icon-button
          class="expander-btn"
          (click)="toggleRow(row)"
          [attr.aria-expanded]="isExpanded(row)"
          [attr.aria-controls]="'detail-' + row.id"
          [@chev]="isExpanded(row) ? 'expanded' : 'collapsed'"
          aria-label="Basculer détails"
        >
          <mat-icon class="expander-icon">chevron_right</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Code -->
    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Code</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ row.code }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Model -->
    <ng-container matColumnDef="model">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Model</th>
      <td mat-cell *matCellDef="let row">
        {{ row.model }}
      </td>
    </ng-container>

    <!-- Condition -->
    <ng-container matColumnDef="condition">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Condition</th>
      <td mat-cell *matCellDef="let row">
        <div style="display: flex; gap: 0.2rem">
          <mat-chip-set>
            <mat-chip [ngClass]="conditionChipColor(row.condition)" selected>
              {{ row.condition | catalog : DOMAIN.CONDITION : 'label' : 'eng' | uppercase }}
            </mat-chip>
          </mat-chip-set>
          <mat-chip-set>
            <mat-chip [ngClass]="conditionChipColor('FINDINGS')" selected> Findings </mat-chip>
          </mat-chip-set>
        </div>
      </td>
    </ng-container>

    <!-- Location -->
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ (isMobile$ | async) ? 'Loc.' : 'Location' }}
      </th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ row.location }}</span>
        <span class="base" *ngIf="row.base">&nbsp;• {{ row.base }}</span>
      </td>
    </ng-container>

    <!-- Compteur-->
    <ng-container matColumnDef="counter">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Left</th>
      <td mat-cell *matCellDef="let row">
        <span class="mono">{{ formatMinutesToHours(row.nextMaintenanceMinutes) ?? '—' }}</span>
      </td>
    </ng-container>

    <!-- Overhaul type -->
    <ng-container matColumnDef="overhaulType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Overhaul type</th>
      <td mat-cell *matCellDef="let row">
        {{ row.overhaulType }}
      </td>
    </ng-container>

    <!-- En-tête -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></tr>

    <!-- Lignes principales -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns; trackBy: trackById" class="data-row"></tr>

    <!-- Colonne 'detail' -->
    <ng-container matColumnDef="detail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="detail-cell">
        <!-- Carte de détail -->
        <div class="detail-card" [id]="'detail-' + row.id" [@detailRow]>
          <!-- Métriques -->
          <aside class="metrics" aria-label="Métriques">
            <div class="metric">
              <div class="label">Current hours</div>
              <div class="value">
                {{ formatMinutesToHours(row.currentCounterMinutes ?? row.counterMinutes) }}
                h
              </div>
            </div>
            <div class="metric">
              <div class="label">Maintenance at</div>
              <div class="value">{{ row.hoursAtMaintenance }}:00 h</div>
            </div>
            <div class="metric">
              <div class="label">Next maintenance</div>
              <div class="value">
                {{ formatMinutesToHours(row.nextMaintenanceMinutes) ?? '—' }}
                h
              </div>
            </div>
            <div class="metric">
              <div class="label">Overhaul type</div>
              <div class="value">
                {{ row.overhaulType }}
                h
              </div>
            </div>
          </aside>
        </div>
      </td>
    </ng-container>

    <!-- Ligne détail (rendue seulement quand ouverte) -->
    <tr mat-row *matRowDef="let row; columns: ['detail']; when: isDetailRow" class="detail-row"></tr>

    <!-- État vide (optionnel mais pratique) -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <span style="padding: 1rem">No aircraft</span>
      </td>
    </tr>
  </table>
</div>
